import { dispatch } from "hf-rt";

const initialState = {
  active: false
};

export default {
  name: "loginPopup",
  actions: {
    showLoginPopup: function(bool) {
      dispatch({ type: "SHOW_LOGIN_POPUP", bool });
    }
  },
  reducers: function(state = initialState, action) {
    switch (action.type) {
      case "SHOW_LOGIN_POPUP":
        return { ...state, active: action.bool };
      default:
        return state;
    }
  }
};
